// extracted by mini-css-extract-plugin
module.exports = {"addon-info-model":"addOnInfoModal_addon-info-model__0XMRa","title":"addOnInfoModal_title__1_5xj"};